import posthog from 'posthog-js';
import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';
import PlotFreeModal from '../../../../ui/modals/map/PlotFreeModal';

/**
 * Free-plot modal (`activeModal === 'plotFree'`).
 * `handleBuyHouse` used to live in MapCanvas and was prop-drilled; body is store
 * + selectedMapObject only, so it lives here verbatim.
 */
export default function PlotFreeHost() {
  const isPlotFreeModalOpen = useMapModalStore((s) => s.activeModal === 'plotFree');
  const isPlotFreeModalOnboarding = useMapModalStore((s) => s.payload.plotFreeOnboarding);
  const realEstateCatalogPlotId = useMapModalStore((s) => s.payload.realEstateCatalogPlotId);
  const setRealEstateCatalogPlotId = useMapModalStore((s) => s.setRealEstateCatalogPlotId);
  const setPlotFreeOnboarding = useMapModalStore((s) => s.setPlotFreeOnboarding);
  const closeModal = useMapModalStore((s) => s.closeModal);
  const openModal = useMapModalStore((s) => s.openModal);
  const selectedMapObject = useMapViewStore((s) => s.selectedMapObject);

  const handleBuyHouse = () => {
    // Після онбордингу PlotFreeModal відкривається з зуму до ділянки без шляху map-click,
    // де зазвичай викликається setRealEstateCatalogPlotId. Без plotId RealEstateModal
    // лишає кнопку покупки disabled (plotId == null).
    const catalogPlotId =
      selectedMapObject?.type === 'plot' &&
      selectedMapObject.owner_id === null &&
      selectedMapObject.id != null
        ? selectedMapObject.id
        : realEstateCatalogPlotId;
    if (catalogPlotId != null) {
      setRealEstateCatalogPlotId(catalogPlotId);
    }
    posthog.capture('buy_house_button_clicked', {
      map_object_id: catalogPlotId ?? null,
    });
    const wasOnboarding = isPlotFreeModalOnboarding;
    closeModal();
    setPlotFreeOnboarding(false);
    setTimeout(() => {
      openModal('realEstate', { realEstateOnboarding: wasOnboarding });
    }, 100);
    // Reward is now claimed before onboarding free-plot modal shows, so no need
    // to defer it for onboarding path here.
  };

  return (
        <PlotFreeModal
          isOpen={isPlotFreeModalOpen}
          onBuyHouse={handleBuyHouse}
          lockForOnboarding={isPlotFreeModalOnboarding}
        />
  );
}
